import { render, staticRenderFns } from "./HomePricing.vue?vue&type=template&id=14799b6d"
import script from "./HomePricing.vue?vue&type=script&lang=js"
export * from "./HomePricing.vue?vue&type=script&lang=js"
import style0 from "./HomePricing.vue?vue&type=style&index=0&id=14799b6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports